import * as actionTypes from "../actionTypes";
export const searchBarChanged = (value) => {
  return {
    type: actionTypes.ClientSideSearch.SEARCH_BAR,
    payload: value,
  };
};
export const stateBarChanged = (value) => {
  return {
    type: actionTypes.ClientSideSearch.STATE_BAR,
    payload: value,
  };
};
export const startDateChanged = (value) => {
  return {
    type: actionTypes.ClientSideSearch.START_DATE,
    payload: value,
  };
};
export const allowToSearch = (value) => {
  return {
    type: actionTypes.ClientSideSearch.SEARCH_START,
    payload: value,
  };
};
export const endDateChanged = (value) => {
  return {
    type: actionTypes.ClientSideSearch.END_DATE,
    payload: value,
  };
};
export const perPageChange = (value) => {
  return {
    type: actionTypes.ClientSideSearch.PER_PAGE,
    payload: value,
  };
};
export const pageChange = (value) => {
  return {
    type: actionTypes.ClientSideSearch.PAGE,
    payload: value,
  };
};
